<div class="mb-6">
  <div class="row mt-4">
    <div class="col">
      <div class="float-right">
        <a class="btn btn-primary mr-2"
           [href]="environment.check_in_site_url" target="_blank"
           ngbTooltip="Use the dedicated Check-In site with a barcode scanner for quick check-in."
           placement="bottom">
          Open Check-In Site
        </a>
        <button class="btn btn-secondary"
              (click)="loadingCheckInStats = true;willRefreshCache = true;reloadSubject.next()">
          Refresh
        </button>
      </div>
      <h1 *ngIf="this.accountService.getDefaultLocation() !== null">Check-Ins for {{ this.accountService.getDefaultLocation().name }}</h1>
      <h1 *ngIf="this.accountService.getDefaultLocation() === null">Loading...</h1>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-4 pr-md-2">
      <div class="card">
        <div class="card-body">
          <p class="card-metric">
            <span [class.text-danger]="locationIsOverCapacity()">{{ (loadingCheckInStats || !checkInStats) ? '--' : checkInStats.currently_checked_in_count }}</span>/{{ (loadingLocation || !location) ? '--' : location.capacity }}
          </p>
          <p class="card-label">Current Capacity</p>
        </div>
      </div>
    </div>
    <div class="col-md-4 px-md-2">
      <div class="card">
        <div class="card-body">
          <p class="card-metric">
            {{ (loadingCheckInStats || !checkInStats) ? '--' : checkInStats.check_ins_today_count }}
          </p>
          <p class="card-label">Daily Check-Ins</p>
        </div>
      </div>
    </div>
    <div class="col-md-4 pl-md-2">
      <div class="card">
        <div class="card-body">
          <p class="card-metric">
            {{ (loadingCheckInStats || !checkInStats) ? '--' : checkInStats.failed_check_ins_count }}
          </p>
          <p class="card-label">Warnings</p>
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mt-4">
    <table class="table check-in-table">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px">
          Alerts
        </th>
      </tr>
      <tr>
        <th scope="col">Customer Name</th>
        <th scope="col">Check-in / Time</th>
        <th scope="col">Warning</th>
      </tr>
      </thead>

      <tbody *ngIf="(failedCheckIns !== undefined) && !loadingFailedCheckIns">
        <tr *ngFor="let failedCheckIn of failedCheckIns">
          <td>
            <a routerLink="/customers/{{ failedCheckIn.customer_id}}">
              {{ failedCheckIn.customer_first_name }} {{ failedCheckIn.customer_last_name }}
            </a>
          </td>
          <td>
            {{ timeStringFromISO8601(failedCheckIn.check_in_datetime) }}
            /
            {{ failedCheckIn.failure_age_minutes }} min
          </td>
          <td>
            <span class="text-danger"
                  *ngFor="let failure_reason of failedCheckIn.failure_reasons">
              {{ failure_reason }}<br>
            </span>
          </td>
        </tr>
        <tr *ngIf="failedCheckIns.length === 0">
          <td colspan="99" class="text-muted">No alerts</td>
        </tr>
      </tbody>

      <tbody *ngIf="loadingFailedCheckIns">
        <tr>
          <td colspan="99" class="text-muted">Loading...</td>
        </tr>
      </tbody>

    </table>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mt-4">
    <table class="table table-hover check-in-table">

      <thead>
      <tr>
        <th scope="col" colspan="99" style="font-size: 16px">
          <span class="cursor-pointer"
                [class.text-primary]="tableChoice === TableChoice.inFacility"
                [class.text-muted]="tableChoice !== TableChoice.inFacility"
                (click)="setTableChoice(TableChoice.inFacility);">
            In Facility
          </span>
          <span class="cursor-pointer ml-2"
                [class.text-primary]="tableChoice === TableChoice.recentCheckIns"
                [class.text-muted]="tableChoice !== TableChoice.recentCheckIns"
                (click)="setTableChoice(TableChoice.recentCheckIns);">
            Recent Check-Ins
          </span>
          <span class="cursor-pointer ml-2"
                [class.text-primary]="tableChoice === TableChoice.recentCheckOuts"
                [class.text-muted]="tableChoice !== TableChoice.recentCheckOuts"
                (click)="setTableChoice(TableChoice.recentCheckOuts);">
            Recent Check-Outs
          </span>
        </th>
      </tr>
      <tr *ngIf="tableChoice === TableChoice.inFacility">
        <th scope="col">Customer Name</th>
        <th scope="col">Check-in / Time</th>
        <th scope="col">Milestones</th>
        <th scope="col">Entry Method</th>
        <th scope="col"></th>
      </tr>
      <tr *ngIf="tableChoice === TableChoice.recentCheckIns">
        <th scope="col">Customer Name</th>
        <th scope="col">Check-in</th>
        <th scope="col">Milestones</th>
        <th scope="col"></th>
      </tr>
      <tr *ngIf="tableChoice === TableChoice.recentCheckOuts">
        <th scope="col">Customer Name</th>
        <th scope="col">Check-out</th>
        <th scope="col">Visit duration</th>
        <th scope="col">Milestones</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <ng-container *ngIf="tableChoice === TableChoice.inFacility">
        <tbody *ngIf="(inFacilityCheckIns !== undefined) && !loadingInFacilityCheckIns">
          <tr *ngFor="let inFacilityCheckIn of inFacilityCheckIns">
            <td class="p-0">
              <div style="padding:12px;padding-right:8px;" class="d-inline-block">
                <a routerLink="/customers/{{ inFacilityCheckIn.customer_id}}">
                  {{ inFacilityCheckIn.customer_first_name }} {{ inFacilityCheckIn.customer_last_name }}
                </a>
              </div>
              <div class="d-inline-block" style="position:relative;top:-1px;">
                <div *ngIf="inFacilityCheckIn.has_medical_notes"
                     ngbTooltip="Has medical notes"
                     class="d-inline">
                  <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
                </div>
                <div *ngIf="inFacilityCheckIn.has_alert_icon"
                     ngbTooltip="Has a profile alert"
                     class="d-inline">
                  <app-alert-icon [size]="0"></app-alert-icon>
                </div>
                <div *ngFor="let proficiency of inFacilityCheckIn.active_proficiencies"
                     class="d-inline" style="padding-right: 1px;" [ngbTooltip]="proficiency.proficiency_name">
                  <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                        [iconInitials]="proficiency.proficiency_icon_initials"
                                        [size]="0">
                  </app-proficiency-icon>
                </div>
                <div *ngFor="let icon of inFacilityCheckIn.membership_icons"
                     class="d-inline" style="padding-right: 2px;" [ngbTooltip]="icon.icon_hover_text">
                  <app-membership-icon [colorHex]="icon.icon_color_hex"
                                        [iconInitials]="icon.icon_initials"
                                        [size]="0">
                  </app-membership-icon>
                </div>
              </div>
            </td>
            <td>
              {{ timeStringFromISO8601(inFacilityCheckIn.check_in_datetime) }}
              /
              {{ inFacilityCheckIn.check_in_age_minutes }} min
            </td>
            <td>
              <span class="text-primary"
                    *ngFor="let milestone of inFacilityCheckIn.milestones">
                {{ milestone }}<br>
              </span>
            </td>
            <td>{{ inFacilityCheckIn.entry_method_description }}</td>
            <td class="table-button-cell">
              <div class="d-flex justify-content-end" style="gap: 12px;">
                <button class="btn btn-sm btn-outline-primary check-in-table-button"
                        (click)="openCheckInDetailModal(inFacilityCheckIn.id)">
                  Details
                </button>
                <button class="btn btn-sm btn-outline-primary check-in-table-button"
                        *ngIf="!checkOutComplete[inFacilityCheckIn.id]"
                        [disabled]="loadingCheckOut[inFacilityCheckIn.id]"
                        [class.disabled]="loadingCheckOut[inFacilityCheckIn.id]"
                        (click)="checkOut(inFacilityCheckIn.id)">
                  {{ loadingCheckOut[inFacilityCheckIn.id] ? 'Loading...' : 'Check out' }}
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="inFacilityCheckIns.length === 0">
            <td colspan="99" class="text-muted">No customers in facility</td>
          </tr>
        </tbody>
        <tbody *ngIf="loadingInFacilityCheckIns">
          <tr>
            <td colspan="99" class="text-muted">Loading...</td>
          </tr>
        </tbody>
      </ng-container>

      <ng-container *ngIf="tableChoice === TableChoice.recentCheckIns">
        <tbody *ngIf="(recentCheckIns !== undefined) && !loadingRecentCheckIns">
          <tr *ngFor="let recentCheckin of recentCheckIns">
            <td>
              <a routerLink="/customers/{{ recentCheckin.customer_id}}">
                {{ recentCheckin.customer_first_name }} {{ recentCheckin.customer_last_name }}
              </a>
            </td>
            <td>
              {{ timeStringFromISO8601(recentCheckin.check_in_datetime) }}
            </td>
            <td>
              <span class="text-primary"
                    *ngFor="let milestone of recentCheckin.milestone_list">
                {{ milestone }}<br>
              </span>
            </td>
            <td class="table-button-cell">
              <button class="btn btn-sm btn-outline-primary check-in-table-button float-right"
                      (click)="openCheckInDetailModal(recentCheckin.id)">
                Details
              </button>
            </td>
          </tr>
          <tr *ngIf="recentCheckIns.length === 0">
            <td colspan="99" class="text-muted">No check-ins today</td>
          </tr>
        </tbody>
        <tbody *ngIf="loadingRecentCheckIns">
          <tr>
            <td colspan="99" class="text-muted">Loading...</td>
          </tr>
        </tbody>
      </ng-container>

      <ng-container *ngIf="tableChoice === TableChoice.recentCheckOuts">
        <tbody *ngIf="(recentCheckOuts !== undefined) && !loadingRecentCheckOuts">
        <tr *ngFor="let recentCheckOut of recentCheckOuts">
          <td>
            <a routerLink="/customers/{{ recentCheckOut.customer_id}}">
              {{ recentCheckOut.customer_first_name }} {{ recentCheckOut.customer_last_name }}
            </a>
          </td>
          <td>
            {{ timeStringFromISO8601(recentCheckOut.check_out_datetime) }}
          </td>
          <td>
            {{ recentCheckOut.visit_duration_minutes }} min
          </td>
          <td>
            <span class="text-primary"
                  *ngFor="let milestone of recentCheckOut.milestone_list">
              {{ milestone }}<br>
            </span>
          </td>
          <td class="table-button-cell">
            <button class="btn btn-sm btn-outline-primary check-in-table-button float-right"
                    (click)="openCheckInDetailModal(recentCheckOut.id)">
              Details
            </button>
          </td>
        </tr>
        <tr *ngIf="recentCheckOuts.length === 0">
          <td colspan="99" class="text-muted">No check-outs today</td>
        </tr>
        </tbody>
        <tbody *ngIf="loadingRecentCheckOuts">
        <tr>
          <td colspan="99" class="text-muted">Loading...</td>
        </tr>
        </tbody>
      </ng-container>

    </table>
  </div>

  <p *ngIf="tableChoice === TableChoice.recentCheckIns" class="text-muted">
    This table displays the 20 most recent check-ins from today.
  </p>
  <p *ngIf="tableChoice === TableChoice.recentCheckOuts" class="text-muted">
    This table displays the 20 most recent check-outs from today.
  </p>
</div>
